<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: { type: Number, default: null },
  maxlength: { type: Number, default: null },
  disabled: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);

function onKeydown(event) {
  if (event.key.length === 1 && props.maxlength && event.target.value.length === props.maxlength) {
    event.preventDefault();
  }
}

function onInput(event) {
  const val = parseInt(event.target.value);
  emit("update:modelValue", isNaN(val) ? null : val);
}
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
  <input
    type="number"
    class="numeric-input"
    :class="{ error }"
    :value="modelValue"
    :disabled
    v-bind="$attrs"
    @keydown="onKeydown"
    @input="onInput"
  />
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.numeric-input {
  width: 4em;
  height: 32px;
  padding: 0 0.5em;
  font-family: inherit;
  font-size: 0.8125rem;
  color: c.$text;
  background-color: c.$white;
  border: 1px solid c.$border;
  border-radius: 6px;
  outline: none;

  &:focus {
    border-color: c.$main;
  }

  &:disabled {
    background-color: c.$grey-lightest;
    cursor: not-allowed;
  }

  &.error {
    border-color: c.$brand-danger;
  }
}
</style>
